import FilterComp from "components/Dashboard/Loan/FilterComp"
import { TableContainer } from "components/Dashboard/Loan/style"
import React, { useMemo, useState } from "react"
import { useQuery } from "react-query"
import { getExecutiveMemo } from "services/MemoService"
import { MEMO_COLUMNS } from "components/Dashboard/Loan/RefferedLoans/appColumns"
import { usePaginate } from "hooks/usePagination"
import { Table } from "antd"

const ExecutiveMemoTable = () => {

	const {page,limit,setPage,setLimit} = usePaginate({baseRoute:"/memo"})
	const [filter, setFilter] = useState("")

	const { data: recMemodata, isLoading } = useQuery("received-memo", ()=>getExecutiveMemo({page,limit}))

	const columns = useMemo(() => MEMO_COLUMNS, [])
	const [data,pagination] = useMemo(() => {
		const receivedMemo = recMemodata?.data?.threads ? recMemodata?.data?.threads : []

		console.log(receivedMemo)

		const pagination = recMemodata?.data?.pagination ? {
			...recMemodata?.data?.pagination,
			total:recMemodata?.data?.total,
		}:{total: 0, page: 1, totalPages: 1}
		return [receivedMemo,pagination]
	}, [recMemodata?.data])

	const filterData = (list)=>{
		return list
	}

	return (
		<>
			<TableContainer>
				<FilterComp filter={filter} setFilter={setFilter} />
				<Table
					pagination={{
						current:page,
						onChange:(pageNumber)=>{
							setPage(pageNumber)
						},
						onShowSizeChange:(_,size)=>{
							setLimit(size)
						},
						pageSize:limit,
						total:pagination.total,
						nextIcon:<button><i className="bi bi-chevron-right"></i></button>,
						prevIcon:<button> <i className="bi bi-chevron-left"></i></button>

					}}
					scroll={{x: "max-content"}}
					loading={isLoading}
					dataSource={filterData(data)}
					columns={columns}
				/>
			</TableContainer>
		</>
	)
}

export default ExecutiveMemoTable
